/* LJCo Fall Feast: mobile swipe-in for Pick Your Plate cards.
   Low-risk by design:
   - Only runs on phones (under 750px), only if IntersectionObserver exists,
     and never for shoppers who prefer reduced motion.
   - Cards are only hidden after this script adds .ljff-swipe-ready, so if the
     script fails to load, nothing is hidden.
   - Touches nothing outside sections marked data-ljff-swipe-root. */
(function () {
  'use strict';

  function reveal(cards) {
    for (var i = 0; i < cards.length; i++) cards[i].classList.add('is-in');
  }

  function init(root) {
    if (!root || root.getAttribute('data-ljff-ready') === '1') return;
    root.setAttribute('data-ljff-ready', '1');

    if (!('IntersectionObserver' in window) || !window.matchMedia) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    var cards = root.querySelectorAll('[data-ljff-swipe]');
    if (!cards.length) return;

    try {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

      for (var i = 0; i < cards.length; i++) io.observe(cards[i]);
      root.classList.add('ljff-swipe-ready');
    } catch (e) {
      root.classList.remove('ljff-swipe-ready');
      reveal(cards);
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-ljff-swipe-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-run when the section is added or edited.
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
